import { themeMaterial } from 'ag-grid-enterprise';
import { darkMuiTheme } from './darkMuiTheme';
import { colorSchemeDark } from 'ag-grid-community';

export const darkAgGridTheme = themeMaterial.withPart(colorSchemeDark).withParams({
    foregroundColor: darkMuiTheme.palette.text.primary,
    headerTextColor: darkMuiTheme.palette.text.primary,
    headerBackgroundColor: darkMuiTheme.palette.background.default,
    oddRowBackgroundColor: 'rgba(0, 0, 0, 0.15)',
    headerColumnResizeHandleColor: darkMuiTheme.palette.divider,
    accentColor: darkMuiTheme.palette.info.main,
    borderRadius: darkMuiTheme.shape.borderRadius,
    headerFontWeight: 'bold',
    rowHeight: 25,
    cellHorizontalPadding: 20,
    iconButtonBorderRadius: darkMuiTheme.shape.borderRadius,
});
